import { useEffect, useState } from "react";
import { ItemsModel } from "../../AutoComplete/remoteHelper";

type ArgType = {
	filteredItems: ItemsModel
	fetchFilteredItemsCallback(filterValue: string | undefined, currentOffset: number): Promise<void>
	filterValue: string | undefined
	loadMoreRef: React.MutableRefObject<null>
}

export const useInteractionObserver = ({ filteredItems, fetchFilteredItemsCallback, filterValue, loadMoreRef }: ArgType) => {
	const [fetching, setFetching] = useState(false);

	useEffect(
		() => {
			// if we fetched all items, or fetching is in progress, skip
			if (filteredItems.items.length === filteredItems.count || fetching) {
				return;
			}

			const callback = async (entries) => {
				const newOffset = filteredItems.items.length;
				// if scrolled to the last item, update offset and trigger new fetch
				if (entries[0].isIntersecting && filteredItems.count && newOffset < filteredItems.count) {
					setFetching(true);
					await fetchFilteredItemsCallback(filterValue, newOffset);
					setFetching(false);
				}
			};

			const observerInstance = new IntersectionObserver(callback, {
				root: null,
				threshold: 0.5,
			});

			const loadMoreElement = loadMoreRef.current;

			if (loadMoreElement) {
				observerInstance.observe(loadMoreElement);
			}

			return () => {
				if (loadMoreElement) {
					observerInstance.unobserve(loadMoreElement);
				}
			}
		},
		[filteredItems, fetchFilteredItemsCallback, loadMoreRef, filterValue, fetching]
	)
}
